module.exports = __webpack_public_path__ + "static/img/guanZhuYouLi_tpyx.fb6ffe61.png";